import {View, Text, TouchableOpacity, Image, Keyboard} from 'react-native';
import React, {useEffect, useState, useRef} from 'react';
import {IBrand, ISegment} from '../../../../types/Filter';
import {styles} from './styles';
import ProductsButton from '../ProductsButton/ProductsButton';
import ProductsCategories from '../ProductsCategories/ProductsCategories';
import {Colors} from '../../../../constants/Colors';
import {Images} from '../../../../constants/Images';
import {useFilterStore} from '../../../../store/FilterStore';
import Carousel from '../Carousel/Carousel';
import {useNavigation} from '@react-navigation/native';
import {AppRoutes} from '../../../../navigation/Routes.types';
import {useFeaturedProducts} from '../../../../hooks/useFeaturedProducts';
import ProductsService from '../../../../services/ProductsService/ProductsService';
import LinearGradient from 'react-native-linear-gradient';
import AsyncStorage from '@react-native-async-storage/async-storage';

interface IFilterParams {
  perPage: number;
  currentPage: number;
  category?: string;
  brand?: string;
  search?: string;
  sort?: string;
  packaging?: string;
}

interface HomeHeaderProps {
  user: any;
  filterParams: IFilterParams;
  setFilterParams: React.Dispatch<React.SetStateAction<IFilterParams>>;
  segments: ISegment[];
  setCatalogData: React.Dispatch<React.SetStateAction<IProduct[] | undefined>>;
  setNewsData: React.Dispatch<React.SetStateAction<any>>;
  setIsNews: (value: boolean) => void;
  selectedCategory: ISegment | undefined;
  setSelectedCategory: (value: ISegment | undefined) => void;
  isNews: boolean;
  setFilterModal: (value: boolean) => void;
  getActiveFiltersCount: () => number;
  handleAddBag: (product: IProduct, quantity: number) => void;
  openProduct: (value: any) => void;
  refreshKey: number;
  forceSuggestedUpdate: boolean;
  setForceSuggestedUpdate: (value: boolean) => void;
  hasFetchedCategories: boolean;
  favoriteProductsCount?: number;
  onLayoutHeader?: (height: number) => void;
  onLayoutAboveMarcas?: (height: number) => void;
  onCategorySelected?: (categoryName: string) => void;
  onFilterChangeShouldScroll?: () => void;
}

export const HomeHeader: React.FC<HomeHeaderProps> = ({
  user,
  filterParams,
  setFilterParams,
  segments,
  setCatalogData,
  setNewsData,
  isNews,
  setFilterModal,
  setIsNews,
  getActiveFiltersCount,
  handleAddBag,
  openProduct,
  refreshKey,
  forceSuggestedUpdate,
  setForceSuggestedUpdate,
  hasFetchedCategories = false,
  favoriteProductsCount,
  onLayoutHeader,
  onLayoutAboveMarcas,
  onCategorySelected,
  onFilterChangeShouldScroll,
}) => {
  const [search, setSearch] = useState<string>('');

  const {brand, category, selectedCategory, setSelectedCategory} =
    useFilterStore();

  const handleClearFilters = () => {
    clearFilters();
  };

  useEffect(() => {
    clearFilters();
  }, []);
  useEffect(() => {
    clearFilters();
  }, [user?.current_client]);

  const clearFilters = () => {
    setCatalogData([]);
    setNewsData([]);
    setSearch('');
    setFilteredBrands([]);
    setSelectedCategory(undefined);
    setIsNews(false);
    setFilterParams({
      perPage: 30,
      currentPage: 1,
      category: undefined,
      brand: undefined,
      search: undefined,
      sort: undefined,
      packaging: undefined,
    });
  };

  useEffect(() => {
    const showSubscription = Keyboard.addListener('keyboardDidShow', () => {
      setShowSugested;
      setShowBanner(false);
      setShowSugested(false);
    });
    const hideSubscription = Keyboard.addListener('keyboardDidHide', () => {
      setShowBanner(true);
      setShowSugested(true);
    });

    return () => {
      showSubscription.remove();
      hideSubscription.remove();
    };
  }, []);
  const [filteredBrands, setFilteredBrands] = useState<IBrand[]>([]);
  const getSelectedCategoryIdByName = (categoryIdVal: string) => {
    const newSelectedCategory = segments.find(
      (segment: ISegment) => segment.name === categoryIdVal,
    );
    setSelectedCategory(newSelectedCategory);
  };
  useEffect(() => {
    setFilteredBrands([]);
    if (selectedCategory && selectedCategory?.category_id) {
      let tempCat = category.find(
        (s: ISegment) =>
          s.name.toLocaleLowerCase() ==
          selectedCategory.name.toLocaleLowerCase(),
      );
      const filtered = brand.filter(
        (b: IBrand) => b.image_segmentation_id == tempCat?.id,
      );

      setFilteredBrands(filtered);
    } else if (selectedCategory && selectedCategory?.id) {
      const filtered = brand.filter(
        (b: IBrand) => b.image_segmentation_id === selectedCategory.id,
      );
      setFilteredBrands(filtered);
    } else if (selectedCategory) {
      const categoryByName = category.find(
        (s: ISegment) =>
          s.name.toLocaleLowerCase() == selectedCategory.toLocaleLowerCase(),
      );
      const filtered = brand.filter(
        (b: IBrand) => b.image_segmentation_id == categoryByName?.id,
      );
      setFilteredBrands(filtered);
    } else {
      setFilteredBrands([]);
    }
  }, [selectedCategory, brand]);
  const removeAccents = (str: string) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };
  const [showBanner, setShowBanner] = useState(true);
  const [showSugested, setShowSugested] = useState(true);
  const navigation = useNavigation();
  
  const {hasFeaturedProducts, loading: loadingFeatured} = useFeaturedProducts(
    user?.clientCode,
  );

  const PROMOTIONS_CACHE_KEY = (clientCode: string) =>
    `@has_promotions_${clientCode}`;

  // Inicia com o valor em cache (evita flash de ausência do CTA no mount)
  const [hasPromotions, setHasPromotions] = useState(false);

  useEffect(() => {
    if (!user?.clientCode) return;
    const cacheKey = PROMOTIONS_CACHE_KEY(user.clientCode);

    // Carrega cache imediatamente para não esconder o CTA enquanto a request carrega
    AsyncStorage.getItem(cacheKey)
      .then(cached => {
        if (cached === 'true') setHasPromotions(true);
      })
      .catch(() => {});

    // Busca atualizado no backend
    ProductsService.catalogProductsGet(
      user.clientCode,
      1,
      1,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      true,
    )
      .then(res => {
        const hasPromo = (res.data?.products?.length ?? 0) > 0;
        setHasPromotions(hasPromo);
        // Persiste resultado para o próximo mount
        AsyncStorage.setItem(cacheKey, hasPromo ? 'true' : 'false').catch(() => {});
      })
      .catch(() => {
        // Em caso de erro de rede, mantém o valor em cache (já carregado acima)
      });
  }, [user?.clientCode]);

  return (
    <View onLayout={(e) => onLayoutHeader?.(e.nativeEvent.layout.height)}>
      <View onLayout={(e) => onLayoutAboveMarcas?.(e.nativeEvent.layout.height)}>
        {showBanner && (
          <>
            <Carousel />
          </>
        )}

        {hasPromotions && (
          <TouchableOpacity
            activeOpacity={0.85}
            onPress={() => navigation.navigate(AppRoutes.OFFERS)}
            style={styles.offersCTAWrapper}>
            <LinearGradient
              colors={['#FF6B00', '#DD0B1C']}
              start={{x: 0, y: 0}}
              end={{x: 1, y: 0}}
              style={styles.offersCTAGradient}>
              <View style={styles.offersCTALeft}>
                <View style={styles.offersCTABadge}>
                  <Text style={styles.offersCTABadgeText}>%</Text>
                </View>
                <View>
                  <Text style={styles.offersCTATitle}>Ofertas Especiais</Text>
                  <Text style={styles.offersCTASubtitle}>Aproveite os preços exclusivos de hoje</Text>
                </View>
              </View>
              <View style={styles.offersCTAArrow}>
                <Text style={styles.offersCTAArrowText}>›</Text>
              </View>
            </LinearGradient>
          </TouchableOpacity>
        )}

        <Text style={styles.categories}>Categorias</Text>
        <ProductsCategories
          segments={segments}
          hasFetchedCategories={hasFetchedCategories}
          returnCategory={(val: string) => {
            onCategorySelected?.(val);
          }}
          featuredItem={{
            show: hasFeaturedProducts && !loadingFeatured,
            imageUrl: '',
            title: 'Imperdíveis',
            onPress: () => navigation.navigate(AppRoutes.FEATURED_PRODUCTS),
          }}
          offersItem={{
            show: false,
            imageUrl: '',
            title: 'Ofertas',
            onPress: () => navigation.navigate(AppRoutes.OFFERS),
          }}
        />
      </View>
      {filteredBrands && filteredBrands.length > 0 && (
        <>
        <Text style={styles.categories}>Marcas</Text>
       <ProductsButton
        brand={filteredBrands}
        onPress={(val: string) => {
          onFilterChangeShouldScroll?.();
          const brandWithoutAccents = removeAccents(val);
          setCatalogData([]);
          setNewsData([]);
          setFilterParams({
            ...filterParams,
            brand: brandWithoutAccents,
            currentPage: 1,
          });
        }}
        goToFavorites={() => null}
      />
        </>
      )}
      <View style={styles.containerFilter}>
        <Text style={styles.products}>{isNews ? 'Novidades' : 'Produtos'}</Text>
        <View style={styles.filtersContainer}>
          {getActiveFiltersCount() > 0 && (
            <TouchableOpacity
              onPress={handleClearFilters}
              style={styles.buttonFilter}>
              <Text style={[styles.filter, {color: Colors.RedPallete.red}]}>
                Limpar Filtros
              </Text>
            </TouchableOpacity>
          )}
          <TouchableOpacity
            onPress={() => setFilterModal(true)}
            style={styles.buttonFilter}>
            <Text
              style={[
                styles.filter,
                {
                  color:
                    getActiveFiltersCount() > 0
                      ? Colors.RedPallete.red
                      : Colors.GrayPallete.lightgrayThree,
                },
              ]}>
              Filtrar
            </Text>
            <View style={styles.iconContainer}>
              <Image
                source={Images.FiltersIcon}
                style={[
                  styles.filterIcon,
                  {
                    tintColor:
                      getActiveFiltersCount() > 0
                        ? Colors.RedPallete.red
                        : Colors.GrayPallete.lightgrayThree,
                  },
                ]}
              />
              {getActiveFiltersCount() > 0 && (
                <View style={styles.badge}>
                  <Text style={styles.badgeText}>
                    {getActiveFiltersCount()}
                  </Text>
                </View>
              )}
            </View>
          </TouchableOpacity>
        </View>
      </View>
      <Text style={styles.textBuy}>
        Compre aqui seus produtos Brasal Refrigerantes!
      </Text>
    </View>
  );
};
